import axiosInstance from "@/api/axios-instance";

export interface Team {
  id: string;
  name: string;
  region_id: string;
  supported_languages: string[];
  status: "ACTIVE" | "INACTIVE";
  products?: Array<{ id: string; name: string }>;
  region_rel?: { id: string; code: string; display_name: string } | null;
  professionals?: Array<{ id: string; name: string }>;
  managed_events?: Array<{ id: string; name: string }>;
  created_at: string;
}

export interface TeamInput {
  name: string;
  product_ids: string[];
  region_id: string;
  supported_languages?: string[];
  status?: "ACTIVE" | "INACTIVE";
  professional_ids?: string[];
}

export async function getTeams(): Promise<Team[]> {
  const r = await axiosInstance.get("/team");
  return r.data.teams ?? [];
}
export async function getTeamsBy(params: {
  product_id?: string;
  region_id?: string;
  status?: string;
}): Promise<Team[]> {
  const r = await axiosInstance.get("/team", { params });
  return r.data.teams ?? [];
}
export async function getTeam(id: string): Promise<Team> {
  const r = await axiosInstance.get(`/team/${id}`);
  return r.data;
}
export async function createTeam(data: TeamInput) {
  return (await axiosInstance.post("/team", data)).data;
}
export async function updateTeam(id: string, data: Partial<TeamInput>) {
  return (await axiosInstance.patch(`/team/${id}`, data)).data;
}
export async function deleteTeam(id: string) {
  return (await axiosInstance.delete(`/team/${id}`)).data;
}
